import React from "react";

import Box from "@mui/material/Box";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Button from "@mui/material/Button";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import WorkIcon from "@mui/icons-material/Work";
import TimelineIcon from "@mui/icons-material/Timeline";

import Logo from "./assets/logo.png";
import MediumIcon from "../Icons/Medium";

import "./styles.scss";

function Header() {
  return (
    <Box sx={{ padding: "60px 0" }} className="header-wrapper">
      <span className="header-logo fade-in">
        ALEX SEKOWSK<span>I</span>
      </span>

      <Box className="contact-bar fade-in-delay">
        <Tooltip 
          title="View Career Journey" 
          placement="top"
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: '#000',
                color: '#fff',
                fontSize: '0.875rem',
                padding: '8px 12px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }
            }
          }}
        >
          <RouterLink to="/" className="icon-link">
            <Button variant="contained">
              <TimelineIcon />
            </Button>
          </RouterLink>
        </Tooltip>
        
        <Tooltip 
          title="View Portfolio Gallery" 
          placement="top"
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: '#000',
                color: '#fff',
                fontSize: '0.875rem',
                padding: '8px 12px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }
            }
          }}
        >
          <RouterLink to="/portfolio" className="icon-link">
            <Button variant="contained">
              <WorkIcon />
            </Button>
          </RouterLink>
        </Tooltip>

        <Tooltip 
          title="GitHub Profile" 
          placement="top"
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: '#000',
                color: '#fff',
                fontSize: '0.875rem',
                padding: '8px 12px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }
            }
          }}
        >
          <Link href="https://www.github.com/aleksUIX" target="_blank">
            <Button variant="contained">
              <GitHubIcon />
            </Button>
          </Link>
        </Tooltip>
        
        <Tooltip 
          title="LinkedIn Profile" 
          placement="top"
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: '#000',
                color: '#fff',
                fontSize: '0.875rem',
                padding: '8px 12px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }
            }
          }}
        >
          <Link
            href="https://www.linkedin.com/in/aleksandersekowski/"
            target="_blank"
          >
            <Button variant="contained">
              <LinkedInIcon />
            </Button>
          </Link>
        </Tooltip>
        
        <Tooltip 
          title="Medium Blog" 
          placement="top"
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: '#000',
                color: '#fff',
                fontSize: '0.875rem',
                padding: '8px 12px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }
            }
          }}
        >
          <Link href="https://medium.com/@aleksander-sekowski" target="_blank">
            <Button variant="contained">
              <MediumIcon />
            </Button>
          </Link>
        </Tooltip>
      </Box>
    </Box>
  );
}

export default Header;
